import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=68025cc3&scoped=true&"
import script from "./Explanation.vue?vue&type=script&lang=js&"
export * from "./Explanation.vue?vue&type=script&lang=js&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=68025cc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68025cc3",
  null
  
)

export default component.exports